module.exports = __webpack_public_path__ + "img/img-054ea6.png";